var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180.2 133.7",
    style: {
      enableBackground: "new 0 0 180.2 133.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3839E;}\n\t.st1{fill:#F27593;}\n\t.st2{fill:#C9DAF1;}\n\t.st3{fill:#346095;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_954"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    className: "st0",
    d: "M90.6,1.7c-50.8,0-77.8,59.8-44.8,98l-2.5,30.8L68.5,116c38.9,15.6,81.3-13,81.3-55 C149.8,28.3,123.3,1.7,90.6,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    className: "st1",
    d: "M89.5,1.1c-50.9,0-77.8,60-44.7,98.1L42.2,131l26.1-15.4c38.8,14.9,80.5-13.8,80.5-55.3 C148.7,27.7,122.2,1.1,89.5,1.1C89.5,1.1,89.5,1.1,89.5,1.1z M89.5,110.8C61.6,110.8,39,88.2,39,60.4C39,32.5,61.6,9.9,89.5,9.9 s50.4,22.6,50.4,50.4l0,0C139.9,88.2,117.3,110.8,89.5,110.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    transform: "translate(0 60.016)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1037",
    x: 5.5,
    y: 0,
    className: "st2",
    width: 8.7,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    transform: "translate(8.909 80.778)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1038",
    x: 5.8,
    y: 1.7,
    transform: "matrix(0.8632 -0.5048 0.5048 0.8632 -0.4156 5.3543)",
    className: "st2",
    width: 7.7,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    transform: "translate(8.334 37.118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1039",
    x: 8,
    y: -0.5,
    transform: "matrix(0.4923 -0.8704 0.8704 0.4923 1.9478 10.2619)",
    className: "st2",
    width: 3.5,
    height: 7.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    transform: "translate(160.919 60.016)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1040",
    x: 5.5,
    y: 0,
    className: "st2",
    width: 8.7,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    transform: "translate(153.218 37.129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1041",
    x: 5.8,
    y: 1.7,
    transform: "matrix(0.8632 -0.5048 0.5048 0.8632 -0.4158 5.3538)",
    className: "st2",
    width: 7.7,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    transform: "translate(153.594 80.756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    x: 8,
    y: -0.5,
    transform: "matrix(0.4923 -0.8704 0.8704 0.4923 1.9478 10.2619)",
    className: "st2",
    width: 3.5,
    height: 7.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    transform: "translate(24.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    className: "st3",
    d: "M17.2,133.7l2.7-33.4C-13.3,60.9,14.6,0,66.5,0c33.7,0,61,27.3,61,61c0,42.6-43,72.4-82.9,56.9 L17.2,133.7z M66.5,3.5c-48.4,0-76.2,57.1-43,95.6l-2.3,28.2L44.3,114c29.3,12.3,63-1.5,75.3-30.8c12.3-29.3-1.5-63-30.8-75.3 C81.7,5,74.1,3.5,66.5,3.5L66.5,3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    transform: "translate(76.478 22.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    className: "st4",
    d: "M20.5,66.4c0,9.9-15.1,9.9-15.1,0C5.5,56.4,20.5,56.4,20.5,66.4z M20.1,0v51.1H5.8V0H20.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    transform: "translate(74.729 21.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    className: "st3",
    d: "M5.5,67.6c0-12.3,18.6-12.3,18.6,0C24,79.8,5.5,79.8,5.5,67.6z M9,67.6c0,7.6,11.6,7.6,11.6,0 C20.5,60,9,60,9,67.6L9,67.6z M23.5,54.2H6V0h17.5V54.2z M9.5,50.7H20V3.5H9.5L9.5,50.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.6b8fb889fe4fae0e2a88043b92ebbb3f.svg";
export { ForwardRef as ReactComponent };